import React from "react";
import PropTypes from "prop-types";
import InvisibleRecaptcha from "components/v3/recaptcha/InvisibleRecaptcha";
import Password from "components/v3/password/Password";
import PrimaryButton from "components/v3/primary-button/PrimaryButton";
import ErrorHandler from "components/v3/error-handler/ErrorHandler";
import SubmitError from "components/v3/submit-error/SubmitError";
import getEnvironmentName from "utils/getEnvironmentName";
import styles from "./styles.module.scss";

class RevalidateBefore extends React.Component {
    constructor(props) {
        super(props);

        this.useRecaptcha = getEnvironmentName() === "production" || props.location.query.skipGrecaptcha !== "true";
        this._onSubmit = this._onSubmit.bind(this);
    }

    componentDidMount() {
        this.props.reauthorizeFromUser();
    }

    _onSubmit(captchaResponse) {
        const { reauthorizeWithPassword, password } = this.props;

        reauthorizeWithPassword(password, {
            useRecaptcha: this.useRecaptcha,
            captchaResponse
        });
    }

    render() {
        const {
            email,
            password,
            thinking,
            reauthorized,
            errors,
            children,
            onPasswordChange,
            grecaptchaApiKey
        } = this.props;

        if (reauthorized) {
            return children;
        }

        const isSubmitButtonDisabled = !password || !!errors["password"];

        return (
            <InvisibleRecaptcha
                useRecaptcha={ this.useRecaptcha }
                formStyles={ styles.revalidate }
                onCaptchaResponse={ this._onSubmit }
                grecaptchaApiKey={ grecaptchaApiKey }
            >
                <h2 className={ styles.title }>Confirm your password</h2>
                <div className={ styles.email }>
                    { email }
                </div>
                <div className={ styles.password }>
                    <Password
                        onChange={ onPasswordChange }
                        placeholder="Enter your password"
                        password={ password }
                    />
                </div>
                <div className={ styles.error }>
                    <ErrorHandler type="reauthorize" errors={ errors }>
                        <SubmitError />
                    </ErrorHandler>
                </div>
                <div className={ styles.nextButton }>
                    <PrimaryButton
                        disabled={ isSubmitButtonDisabled }
                        thinking={ thinking }
                        text="Next"
                    />
                </div>
            </InvisibleRecaptcha>
        );
    }
}

RevalidateBefore.propTypes = {
    password: PropTypes.string.isRequired,
    thinking: PropTypes.string,
    reauthorized: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    onPasswordChange: PropTypes.func.isRequired,
    reauthorizeFromUser: PropTypes.func.isRequired,
    reauthorizeWithPassword: PropTypes.func.isRequired,
    grecaptchaApiKey: PropTypes.string.isRequired
};

export default RevalidateBefore;
